export default function AiSummaryCard(props) {
  const { metaJson, layout } = props;
  const { aiSummary } = layout;
  return (
    <idk-div
      style={{
        flexGrow: 1,
        borderRadius: layout?.cardSettings?.cardBorder,
        backgroundColor: layout?.cardSettings?.cardBackgroundColor,
      }}
      class="zid-flex-col zid-justify-start zid-py-[20px] zid-px-[20px] zid-gap-2 zid-relative zid-h-full zid-w-full zid-flex zid-ai-card"
    >
      <idk-div
        dangerouslySetInnerHTML={{
          __html: aiSummary?.header?.replace('{nr_reviews_source}', metaJson?.[0]?.totalReview?.toLocaleString() || ''),
        }}
        class="idk-ai-summary-header"
      />
      <idk-div dangerouslySetInnerHTML={{ __html: aiSummary?.content || '' }} class="idk-ai-summary-content" />
    </idk-div>
  );
}
